import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import useZipCascade from '../../../hooks/useZipCascade';
import { emptyValues as emptyContactValues } from '../../Customer/client.constants';
import * as actions from '../../../redux/actions';

// เปิด/ปิด dialog สร้างลูกค้าใหม่แบบ inline (ไม่ navigate ออกจากหน้า) — เมื่อสร้างสำเร็จ
// จะเรียก onCreated(created) ให้ผู้เรียกตั้งเป็นลูกค้าที่เลือกทันที
export function useContactCreate({ onCreated }) {
  const dispatch = useDispatch();
  const [addContactOpen, setAddContactOpen] = useState(false);
  const [contactSaving, setContactSaving] = useState(false);
  const [contactError, setContactError] = useState('');

  const {
    handleSubmit: handleContactSubmit,
    control: contactControl,
    reset: resetContactForm,
    setValue: setContactValue,
    watch: watchContact,
  } = useForm({ defaultValues: emptyContactValues });
  const { cascade: contactCascade, setZipSelections: setContactZipSelections } = useZipCascade(watchContact, setContactValue);

  const openAddContact = () => {
    resetContactForm(emptyContactValues);
    setContactZipSelections({ province: null, district: null });
    setContactError('');
    setAddContactOpen(true);
  };
  const closeAddContact = () => setAddContactOpen(false);

  const submitAddContact = async (data) => {
    setContactSaving(true);
    try {
      const created = await dispatch(actions.contactCreate({ ...data, role: 'client' }));
      onCreated(created);
      setAddContactOpen(false);
    } catch (err) {
      setContactError(err.message || 'สร้างลูกค้าไม่สำเร็จ');
    } finally {
      setContactSaving(false);
    }
  };

  return {
    addContactOpen,
    openAddContact,
    closeAddContact,
    contactControl,
    contactCascade,
    setContactZipSelections,
    contactSaving,
    contactError,
    handleAddContactSubmit: handleContactSubmit(submitAddContact),
  };
}

export default useContactCreate;
